import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { VuePlugin } from 'vuera'
import VueMeta from 'vue-meta'
import './index.css';

Vue.use(VuePlugin)
Vue.use(VueMeta)

Vue.config.productionTip = false

new Vue({
  components: { App },
  router,
  template: '<App/>'
}).$mount('#app')
